import { ICrudComponentPanel } from '../interfaces/ICrudComponentPanel';

export class PanelItemKey {

  constructor(public key: string, public value: ICrudComponentPanel) {

  }

}
